import { render, staticRenderFns } from "./EditStage.vue?vue&type=template&id=500b3981"
import script from "./EditStage.vue?vue&type=script&lang=js"
export * from "./EditStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditStage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500b3981')) {
      api.createRecord('500b3981', component.options)
    } else {
      api.reload('500b3981', component.options)
    }
    module.hot.accept("./EditStage.vue?vue&type=template&id=500b3981", function () {
      api.rerender('500b3981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/EditStage.vue"
export default component.exports